// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-search-container {
   display: flex;
   justify-content: space-between;
   width: calc(100% - 10px);
   min-width: 200px;
   margin: 5px;
}

.ecl-search-container svg {
   margin-top: 7.5px;
   height: 25px;
   width: 25px;
   min-height: 25px;
   min-width: 25px;
}

.search-widget {
   display: flex;
   flex-wrap: nowrap;
   align-items: center;
   width: calc(100% - 30px);
   border: var(--border);
   border-radius: var(--border-radius);
   overflow: auto;
}

.search-widget .searchable-input {
   display: flex;
   flex-wrap: nowrap;
}

.search-widget > input {
   min-width: 100px;
   margin: 5px;
}

.ecl-search-container .searchable-input .searchable-input-combo {
   min-width: 100px;
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: var(--button-primary);
   border-radius: var(--border-radius);
   margin: 5px;
   color: var(--button-primary-text)
}

.ecl-search-container .search-widget .searchable-input .filtered-searchable {
   background-color: var(--jade-glow);
   border-radius: var(--border-radius);
}

.ecl-search-container .searchable-input .searchable-input-combo button {
   background-color: transparent;
   margin: 0;
   font-weight: 600;
}

.ecl-search-container .searchable-input .searchable-input-combo button:first-child {
   text-align: left;
}

.ecl-search-container .searchable-input .searchable-input-combo button:last-child{
   display: flex;
   justify-content: center;
   align-items: center;
}

.ecl-search-container .searchable-input .searchable-input-combo button svg {
   margin: 0;
}

.search-input-form {
   width: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}

.search-input-form input, .search-input-form .ecl-select-new {
   width: 100%;
}

.search-select-container {
   display: flex;
   border-radius: var(--border-radius);
   align-items: center;
}

.search-select-container .search-select-combo {
   display: flex;
   overflow: hidden;
   align-items: center;
   color: var(--button-primary-text)
}

.search-select-combo label {
   font-weight: bold;
   padding-top: 0;
   padding-bottom: 0;
   text-transform: capitalize;
}

.search-select-combo p {
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   padding: 0;
   font-weight: normal;
   max-width: 125px;
}

.search-input-form-preview {
   padding: 0;
   margin: 0;
   margin-left: 5px;
   margin-right: 5px;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   padding: 0;
   font-weight: normal;
   max-width: 125px;
}

@media (min-width: 769px) and (orientation: portrait),
(min-height: 769px) and (orientation: landscape) {
   .search-widget {
      flex-wrap: wrap;
   }

   .search-widget .searchable-input {
      flex-wrap: wrap;
   }

   .ecl-search-container svg {
      margin-top: 2.5px;
   }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLSearch/ECLSearch.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,8BAA8B;GAC9B,wBAAwB;GACxB,gBAAgB;GAChB,WAAW;AACd;;AAEA;GACG,iBAAiB;GACjB,YAAY;GACZ,WAAW;GACX,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,aAAa;GACb,iBAAiB;GACjB,mBAAmB;GACnB,wBAAwB;GACxB,qBAAqB;GACrB,mCAAmC;GACnC,cAAc;AACjB;;AAEA;GACG,aAAa;GACb,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,WAAW;AACd;;AAEA;GACG,gBAAgB;GAChB,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,uCAAuC;GACvC,mCAAmC;GACnC,WAAW;GACX;AACH;;AAEA;GACG,kCAAkC;GAClC,mCAAmC;AACtC;;AAEA;GACG,6BAA6B;GAC7B,SAAS;GACT,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,SAAS;AACZ;;AAEA;GACG,WAAW;GACX,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,aAAa;GACb,mCAAmC;GACnC,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,mBAAmB;GACnB;AACH;;AAEA;GACG,iBAAiB;GACjB,cAAc;GACd,iBAAiB;GACjB,0BAA0B;AAC7B;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;GACvB,UAAU;GACV,mBAAmB;GACnB,gBAAgB;AACnB;;AAEA;GACG,UAAU;GACV,SAAS;GACT,gBAAgB;GAChB,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;GACvB,UAAU;GACV,mBAAmB;GACnB,gBAAgB;AACnB;;AAEA;;GAEG;MACG,eAAe;GAClB;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,iBAAiB;GACpB;AACH","sourcesContent":[".ecl-search-container {\r\n   display: flex;\r\n   justify-content: space-between;\r\n   width: calc(100% - 10px);\r\n   min-width: 200px;\r\n   margin: 5px;\r\n}\r\n\r\n.ecl-search-container svg {\r\n   margin-top: 7.5px;\r\n   height: 25px;\r\n   width: 25px;\r\n   min-height: 25px;\r\n   min-width: 25px;\r\n}\r\n\r\n.search-widget {\r\n   display: flex;\r\n   flex-wrap: nowrap;\r\n   align-items: center;\r\n   width: calc(100% - 30px);\r\n   border: var(--border);\r\n   border-radius: var(--border-radius);\r\n   overflow: auto;\r\n}\r\n\r\n.search-widget .searchable-input {\r\n   display: flex;\r\n   flex-wrap: nowrap;\r\n}\r\n\r\n.search-widget > input {\r\n   min-width: 100px;\r\n   margin: 5px;\r\n}\r\n\r\n.ecl-search-container .searchable-input .searchable-input-combo {\r\n   min-width: 100px;\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n   background-color: var(--button-primary);\r\n   border-radius: var(--border-radius);\r\n   margin: 5px;\r\n   color: var(--button-primary-text)\r\n}\r\n\r\n.ecl-search-container .search-widget .searchable-input .filtered-searchable {\r\n   background-color: var(--jade-glow);\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n.ecl-search-container .searchable-input .searchable-input-combo button {\r\n   background-color: transparent;\r\n   margin: 0;\r\n   font-weight: 600;\r\n}\r\n\r\n.ecl-search-container .searchable-input .searchable-input-combo button:first-child {\r\n   text-align: left;\r\n}\r\n\r\n.ecl-search-container .searchable-input .searchable-input-combo button:last-child{\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.ecl-search-container .searchable-input .searchable-input-combo button svg {\r\n   margin: 0;\r\n}\r\n\r\n.search-input-form {\r\n   width: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.search-input-form input, .search-input-form .ecl-select-new {\r\n   width: 100%;\r\n}\r\n\r\n.search-select-container {\r\n   display: flex;\r\n   border-radius: var(--border-radius);\r\n   align-items: center;\r\n}\r\n\r\n.search-select-container .search-select-combo {\r\n   display: flex;\r\n   overflow: hidden;\r\n   align-items: center;\r\n   color: var(--button-primary-text)\r\n}\r\n\r\n.search-select-combo label {\r\n   font-weight: bold;\r\n   padding-top: 0;\r\n   padding-bottom: 0;\r\n   text-transform: capitalize;\r\n}\r\n\r\n.search-select-combo p {\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   padding: 0;\r\n   font-weight: normal;\r\n   max-width: 125px;\r\n}\r\n\r\n.search-input-form-preview {\r\n   padding: 0;\r\n   margin: 0;\r\n   margin-left: 5px;\r\n   margin-right: 5px;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   padding: 0;\r\n   font-weight: normal;\r\n   max-width: 125px;\r\n}\r\n\r\n@media (min-width: 769px) and (orientation: portrait),\r\n(min-height: 769px) and (orientation: landscape) {\r\n   .search-widget {\r\n      flex-wrap: wrap;\r\n   }\r\n\r\n   .search-widget .searchable-input {\r\n      flex-wrap: wrap;\r\n   }\r\n\r\n   .ecl-search-container svg {\r\n      margin-top: 2.5px;\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
